import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import drop_down_icon from "../../assets/icons/drop_down_icon.png";
import add_image_icon from "../../assets/icons/add_image_icon.png";
import india_flag_icon from "../../assets//icons/india_flag_icon.png";
import calender_icon from "../../assets/icons/calender_icon.png";
import hamburger_icon from "../../assets/icons//hamburger_icon.png";
import Sidebar from "./AdminComponents/Sidebar";

const AdminCreate = () => {
  const [selectedOption, setSelectedOption] = useState("");
  const [selectAgent, setSelectAgent] = useState("");
  const [showSecondMobileNumber, setShowSecondMobileNumber] = useState(false);
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };
  return (
    <>
      <div>
        <div className="flex items-center justify-center w-full">
          <div
            className="items-center justify-center hidden hamburger"
            onClick={toggleNavbar}
          >
            <img
              src={hamburger_icon}
              alt="hamburger"
              className="object-contain"
            />
          </div>
          <div className="flex items-center justify-center w-full">
            <SearchBar categoryName="Dashboard" />
          </div>
          <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
            {isNavbarVisible && <Sidebar />}
          </div>
        </div>
        <div className="ml-4 mt-6 w-[70%] mb-16 create--page">
          <div className="flex">
            <p className="text-[14px] mr-2">Prospect Entry Form</p>
            <div>
              <img src={drop_down_icon} alt="drop-dowm" />
            </div>
          </div>
          {/*  */}
          <div className="mt-4">
            <p className="text-[14px] text-[#828282]">Assign to</p>
            <div className="flex">
              <select
                name="Search & select contact person"
                className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
                value={selectAgent}
                onChange={(e) => setSelectAgent(e.target.value)}
              >
                <option value="" disabled hidden>
                  Select the contact person
                </option>
                <option value="Praveen Sharma">Praveen Sharma</option>
              </select>
            </div>
          </div>

          {/*  */}
          <div className="flex mt-4">
            <div className="mr-2">
              <img src={add_image_icon} alt="add image" />
            </div>
            <div className="w-full">
              <p className="text-[14px] text-[#BDBDBD]">Company/Store Name</p>
              <div>
                <input
                  type="text"
                  placeholder="Enter the company/store name"
                  className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
                />
              </div>
              <div className="flex items-center mt-2">
                <input type="checkbox" className="mr-2" />
                <p className="text-[14px] text-[#828282]">
                  Company name and store name is different.
                </p>
              </div>
            </div>
          </div>
          <p className="text-[14px] text-[#828282] mt-4">Primary Contact</p>
          <input
            type="text"
            placeholder="Enter the first & last name of the contact"
            className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
          />
          <p className="text-[14px] text-[#828282] mt-4">Mobile Number</p>
          <div className="flex border w-full border-[#95C2FF] p-2 rounded-lg">
            <img
              src={india_flag_icon}
              className="cursor-pointer"
              alt="india flag"
            />
            <input
              type="number"
              placeholder="Enter the number"
              className="text-[16px] w-full ml-2"
            />
          </div>
          <div className="flex items-center mt-1">
            <input
              type="checkbox"
              onChange={() =>
                setShowSecondMobileNumber(!showSecondMobileNumber)
              }
            />
            <p className="text-[14px] ml-1">Whatsapp number is not similar</p>
          </div>
          {showSecondMobileNumber && (
            <div>
              <p className="text-[14px] text-[#828282] mt-4">Mobile Number</p>
              <div className="flex border w-full border-[#95C2FF] p-2 rounded-lg">
                <img
                  src={india_flag_icon}
                  className="cursor-pointer"
                  alt="india flag"
                />
                <input
                  type="number"
                  placeholder="Enter the number"
                  className="text-[16px] w-full ml-2"
                />
              </div>
            </div>
          )}
          <p className="text-[14px] text-[#828282] mt-4">Email Address</p>
          <input
            type="email"
            placeholder="Enter the email address"
            className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
          />
          <div className="bg-[#F8F8F8] mt-4 p-4 rounded-lg">
            <p className="italic text-[12px]">Agent & Distributor</p>
            <div className="flex w-full">
              <div className="w-full">
                <div className="text-[14px] mt-3">Agent</div>
                <div className="flex mt-1">
                  <div className="text-[16px] border border-[#2F80ED] p-2 w-[80%] rounded-lg">
                    <select
                      value={selectedOption}
                      onChange={(e) => setSelectedOption(e.target.value)}
                      className="w-full bg-[#F8F8F8]"
                    >
                      <option value="" disabled hidden>
                        Enter the agent name
                      </option>
                      <option value="person1">Amit Gupta</option>
                      <option value="person2">Rohit Mehta</option>
                    </select>
                  </div>
                  <div className="bg-[#E8E8E8] flex justify-center w-[2.3rem] items-center ml-2 rounded-md">
                    <p className="text-[30px] cursor-pointer">+</p>
                  </div>
                </div>
              </div>

              <div className="w-full">
                <div className="text-[14px] mt-3">Distributor</div>
                <div className="flex mt-1">
                  <div className="text-[16px] border border-[#2F80ED] p-2 w-[80%] rounded-lg">
                    <select
                      value={selectedOption}
                      onChange={(e) => setSelectedOption(e.target.value)}
                      className="w-full bg-[#F8F8F8]"
                    >
                      <option value="" disabled hidden>
                        Enter the distributor name
                      </option>
                      <option value="person1">Amit Gupta</option>
                      <option value="person2">Rohit Mehta</option>
                    </select>
                  </div>
                  <div className="bg-[#E8E8E8] flex justify-center w-[2.3rem] items-center ml-2 rounded-md">
                    <p className="text-[30px] cursor-pointer">+</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Next */}

          <div className="bg-[#F8F8F8] mt-4 p-4 rounded-lg">
            <p className="italic text-[12px]">Prospect Details</p>
            <div className="flex w-full">
              <div className="w-full">
                <div className="text-[14px] mt-3">Designation</div>
                <div className="flex mt-1">
                  <div className="w-[90%] ">
                    <input
                      type="text"
                      placeholder="Enter the designation"
                      className="bg-[#F8F8F8] text-[16px] border border-[#2F80ED] w-full rounded-lg p-2"
                    />
                  </div>
                </div>
              </div>

              <div className="w-full">
                <div className="text-[14px] mt-3">Date Of Birth</div>
                <div className="flex mt-1">
                  <div className="text-[16px] border border-[#2F80ED] p-2 w-[80%] rounded-lg">
                    <input type="date" className="w-full bg-[#F8F8F8]" />
                  </div>
                  <div className="ml-2">
                    <img
                      src={calender_icon}
                      className=" w-[2.1rem] "
                      alt="calender"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex mt-4 w-full">
              <div className="w-full">
                <div className="text-[14px]">Instagram Handle</div>
                <div>
                  <input
                    type="text"
                    placeholder="Enter the instagram handle"
                    className="text-[16px] border border-[#2F80ED] p-2 w-[90%] rounded-lg"
                  />
                </div>
              </div>
              <div className="w-full">
                <div className="text-[14px]">Facebook Handle</div>
                <div>
                  <input
                    type="text"
                    placeholder="Enter the facebook handle"
                    className="text-[16px] border border-[#2F80ED] p-2 w-[90%] rounded-lg"
                  />
                </div>
              </div>
              <div className="w-full">
                <div className="text-[14px]">Linkedin Handle</div>
                <div>
                  <input
                    type="text"
                    placeholder="Enter the linkedin handle"
                    className="text-[16px] border border-[#2F80ED] p-2 w-[90%] rounded-lg"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Next */}
          <p className="text-[14px] mt-4">Notes</p>
          <div>
            <input
              placeholder="Please enter if any notes"
              className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
            />
          </div>

          <div className="mt-4 flex w-full justify-between items-center create-foot">
            <div className="mt-8 text-[#2F80ED] text-[16px] underline font-bold cursor-pointer">
              Save & Create New
            </div>
            <div className="flex text-[14px] w-[50%] justify-end mt-8">
              <button className=" bg-white text-[#2F80ED] font-bold border border-[#95C2FF] p-2 rounded-lg w-[30%] action--buttons">
                Discard
              </button>
              <div className="bg-[#2F80ED] ml-2 p-2 text-white rounded-lg w-[30%] text-center action--buttons cursor-pointer">
                Send
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminCreate;
